<div class="unauthorized-page">
  <div class="image-wrapper">
    <img src="/assets/images/unauthorized.png" alt="Unauthorized Access" />
  </div>

  <a href="/social-ai" class="btn">Go to Homepage</a>
</div>
